<!--

 -->

<template>
  <oxd-dialog
    :style="{width: '90%', maxWidth: '450px'}"
    @update:show="onCancel"
  >
    <div class="gsl-hrm-modal-header">
      <oxd-text tag="h6" class="gsl-hrm-main-title">
        {{ $t('general.about') }}
      </oxd-text>
    </div>
    <oxd-divider />
    <div v-if="isLoading" class="gsl-hrm-loader">
      <oxd-loading-spinner />
    </div>
    <oxd-grid v-else :cols="2" class="gsl-hrm-about">
      <oxd-grid-item>
        <oxd-text tag="p" class="gsl-hrm-about-title">
          {{ $t('general.company_name') }}:
        </oxd-text>
      </oxd-grid-item>
      <oxd-grid-item>
        <oxd-text tag="p" class="gsl-hrm-about-text">
          {{ data.companyName }}
        </oxd-text>
      </oxd-grid-item>
      <oxd-grid-item>
        <oxd-text tag="p" class="gsl-hrm-about-title">
          {{ $t('general.version') }}:
        </oxd-text>
      </oxd-grid-item>
      <oxd-grid-item>
        <oxd-text tag="p" class="gsl-hrm-about-text">
          {{ data.productName }} {{ data.version }}
        </oxd-text>
      </oxd-grid-item>
      <template v-if="data.numberOfActiveEmployee !== undefined">
        <oxd-grid-item>
          <oxd-text tag="p" class="gsl-hrm-about-title">
            {{ $t('general.active_employees') }}:
          </oxd-text>
        </oxd-grid-item>
        <oxd-grid-item>
          <oxd-text tag="p" class="gsl-hrm-about-text">
            {{ data.numberOfActiveEmployee }}
          </oxd-text>
        </oxd-grid-item>
      </template>
      <template v-if="data.numberOfPastEmployee !== undefined">
        <oxd-grid-item>
          <oxd-text tag="p" class="gsl-hrm-about-title">
            {{ $t('general.employees_terminated') }}:
          </oxd-text>
        </oxd-grid-item>
        <oxd-grid-item>
          <oxd-text tag="p" class="gsl-hrm-about-text">
            {{ data.numberOfPastEmployee }}
          </oxd-text>
        </oxd-grid-item>
      </template>
    </oxd-grid>
  </oxd-dialog>
</template>

<script>
import {APIService} from '@/core/util/services/api.service';
import {OxdDialog, OxdSpinner} from '@ohrm/oxd';

export default {
  components: {
    'oxd-loading-spinner': OxdSpinner,
    'oxd-dialog': OxdDialog,
  },
  emits: ['close'],
  setup() {
    const http = new APIService(window.appGlobal.baseUrl, '/api/v2/core/about');
    return {
      http,
    };
  },
  data() {
    return {
      isLoading: false,
      data: null,
    };
  },
  beforeMount() {
    this.isLoading = true;
    this.http
      .getAll()
      .then((response) => {
        const {data} = response.data;
        this.data = {...data};
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    onCancel() {
      this.$emit('close', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.gsl-hrm-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80px;
}
.gsl-hrm-about {
  grid-template-columns: 150px 1fr;
  &-title,
  &-text {
    word-break: break-word;
    font-size: $oxd-input-control-font-size;
  }
  &-title {
    font-weight: 700;
  }
}
</style>
